import * as services from "./services";

export async function getSettlementsAction({ commit }, userId) {
  commit("SET_PROCESSING", true);
  try {
    const { data } = await services.getByDriver(userId);
    commit("SET_SETTLEMENTS", data);
    commit("SET_SHOW_SETTLEMENTS", data.length > 0);
    return { success: true, data };
  } catch (e) {
    commit("SET_SETTLEMENTS", []);
    return { success: false, message: e.message };
  } finally {
    commit("SET_PROCESSING", false);
  }
}

export async function getShowSettlementsAction({ commit }, userId) {
  try {
    const { data } = await services.getByDriver(userId);
    commit("SET_SHOW_SETTLEMENTS", data.length > 0);
  } catch {
    commit("SET_SHOW_SETTLEMENTS", false);
  }
}

export async function importFriscoAction({ commit }, file) {
  commit("SET_PROCESSING", true);
  try {
    const { data } = await services.importFrisco(file);
    commit("SET_IMPORT_RESULT", data);
    return { success: true, data };
  } catch (e) {
    return { success: false, message: e?.toString() || "Błąd importu" };
  } finally {
    commit("SET_PROCESSING", false);
  }
}

export async function importAuchanAction({ commit }, file) {
  commit("SET_PROCESSING", true);
  try {
    const { data } = await services.importAuchan(file);
    commit("SET_IMPORT_RESULT", data);
    return { success: true, data };
  } catch (e) {
    return { success: false, message: e?.toString() || "Błąd importu" };
  } finally {
    commit("SET_PROCESSING", false);
  }
}

export async function downloadTemplateAction(_, project) {
  try {
    const response = await services.getTemplate(project);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `szablon_rozliczenie_${project}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (e) {
    return { success: false, message: e.message };
  }
}
